import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";

export const PublicRoute = ({ component: Component, ...rest }) => {
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

const PrivateRoute = ({
  component: Component,
  auth,
  vendorAccess,
  ...rest
}) => {
  let host = window.location.host;
  let fallback = host.includes("admin") ? "/admin-login" : "/";
  return (
    <Route
      {...rest}
      render={(props) =>
        auth.isAuthenticated === true ? (
          !auth.user.VendorUser.have_vendor_submitted_details ? (
            <Fragment>
              <Redirect to="/mapsetup" />
            </Fragment>
          ) : auth.user.VendorUser.role === "vendor" ||
            (auth.user.VendorUser.role === "superadmin" &&
              vendorAccess?.vendor_id) ? (
            <Fragment>
              <Component {...props} />
            </Fragment>
          ) : (
            <Fragment>
              <Redirect to={fallback} />
            </Fragment>
          )
        ) : (
          <Fragment>
            {" "}
            <Redirect to={fallback} />
          </Fragment>
        )
      }
    />
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  vendorAccess: state.vendorAccess,
});

export default connect(mapStateToProps, {})(PrivateRoute);
